import { RefObject, useEffect } from 'react';

interface UseClickOutsideForFavoriteSelectProps {
	isFavorite: boolean;
	multiSelectWrapperRef: RefObject<HTMLDivElement>;
	selectRef: RefObject<any>;
	onMenuClose?: () => void;
}

export const useClickOutsideForFavoriteSelect = ({
	isFavorite,
	multiSelectWrapperRef,
	selectRef,
	onMenuClose,
}: UseClickOutsideForFavoriteSelectProps) => {
	useEffect(() => {
		if (!isFavorite) return;

		const handleDocumentMouseDown = (event: MouseEvent) => {
			const targetNode = event.target as Node | null;
			const targetEl = event.target as Element | null;
			const multiSelectWrapperElement =
				multiSelectWrapperRef.current as (Node & ParentNode) | null;
			const isClickInsideMultiSelectWrapper =
				!!(targetNode && multiSelectWrapperElement?.contains(targetNode));
			const isClickInsideMenu =
				!!(targetEl?.closest('.f5gSelectMenuList'));
			const isClickOutsideMultiSelect =
				!isClickInsideMultiSelectWrapper && !isClickInsideMenu;

			if (isClickOutsideMultiSelect) {
				const selectComponentInstance = selectRef.current as any;

				selectComponentInstance?.onMenuClose?.();
				selectComponentInstance?.blur?.();
				onMenuClose?.();
			}
		};

		document.addEventListener('mousedown', handleDocumentMouseDown, true);

		return () => document.removeEventListener('mousedown', handleDocumentMouseDown, true);
	}, [isFavorite, onMenuClose, multiSelectWrapperRef, selectRef]);
};
